export default __webpack_public_path__ + "src/static/img/png/v2/about-us/section-one-arch-left.png";